import * as d3 from 'd3'

export default {

  data: () => ({
    selectedItems:    null,
    getItems:         null,
  }),

  methods: {
    set_selectedItems() {
      this.selectedItems = { 
        ...this.selectedItems,
        current: JSON.parse(JSON.stringify(this.current))
      }
    },

    draw_PDF() {

      this.current.SVG = this.getItems.current.SVG
      this.call_Layout()

    },
  }
}